import { render, staticRenderFns } from "./EditPlayerModal.vue?vue&type=template&id=5d741492&scoped=true&"
import script from "./EditPlayerModal.vue?vue&type=script&lang=js&"
export * from "./EditPlayerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d741492",
  null
  
)

export default component.exports